;(function () {
  'use strict'
  angular
    .module('contrast.remediation-policy')
    .directive(
      'remediationPolicyThermometerWarningStub',
      remediationPolicyThermometerWarningStub
    )

  function remediationPolicyThermometerWarningStub() {
    return {
      restrict: 'E',
      templateUrl:
        'components/remediation-policy/remediation-policy-thermometer-warning-stub.html'
    }
  }
})()
